const COMMON_EN = {
  delete: 'Delete',
  httpError_400: 'Bad Request',
  httpError_401: 'The username or password is incorrect',
  httpError_500: 'Something bad happened on the server',
  httpSuccess: 'Call has been successful',
  needHelp: 'Need help?',
  redirect: 'You will be redirected soon',
  remove: 'Remove',
};

export default COMMON_EN;
